import type { DOMEvent } from '../types/html-event-target'

function navigatable (selector: string) {
  return selector === '.gallery figure > a'
}

function removePhotoModal (): void {
  const modal = document.getElementById('photoModal')
  if (modal) {
    modal.remove()
  }

  const { body } = document
  body.style.height = 'auto'
  body.style.overflow = 'auto'
}

function photoModal (event: DOMEvent<HTMLElement>, selector: string): void {
  event.preventDefault()

  removePhotoModal()

  const close = document.createElement('button')
  close.innerText = 'X'
  close.className = 'photo-modal-close'
  close.addEventListener('click', removePhotoModal)
  close.title = 'Close'

  const modal = document.createElement('div')
  modal.id = 'photoModal'
  modal.className = 'photo-modal'
  modal.addEventListener('click', removePhotoModal)
  modal.appendChild(close)

  const photoImg = document.createElement('img')
  const eventTargetElement = event.currentTarget as HTMLAnchorElement
  photoImg.src = eventTargetElement.href
  photoImg.className = 'photo-modal-image'

  modal.appendChild(photoImg)

  if (navigatable(selector)) {
    const photoModalTooltip = document.createElement('div')
    photoModalTooltip.className = 'photo-modal-tooltip'
    photoModalTooltip.innerText = 'Swipe or use arrow keys to navigate through gallery'
    modal.appendChild(photoModalTooltip)
  }

  const { body } = document
  body.style.height = '100%'
  body.style.overflow = 'hidden'
  body.appendChild(modal)
}

function addNavigation (selector: string): void {
  if (!navigatable(selector)) return
  let touchstartX = 0
  let touchendX = 0
  const minSwipeDistance = 50

  document.onkeydown = (e) => handleKeyDown(e)

  document.addEventListener('touchstart', e => {
    touchstartX = e.changedTouches[0].screenX
  })

  document.addEventListener('touchend', e => {
    touchendX = e.changedTouches[0].screenX
    handleSwipe()
  })

  function handleSwipe (): void {
    if (touchstartX - touchendX > minSwipeDistance) navigate(1)
    if (touchendX - touchstartX > minSwipeDistance) navigate(-1)
  }

  function handleKeyDown (e: KeyboardEvent): void {
    if (leftArrowPressed(e.key)) {
      navigate(-1)
    } else if (rightArrowPressed(e.key)) {
      navigate(1)
    }
  }

  function navigate (direction: number): void {
    const elements: HTMLAnchorElement[] = Array.from(document.querySelectorAll(selector))
    const modal = document.getElementById('photoModal')
    if (modal) {
      const photoImg: HTMLImageElement = document.querySelector('.photo-modal-image')
      const indexOfClickedElement = elements.findIndex((element) => element.href === photoImg.src)
      const indexToElementToNavigateTo = indexOfClickedElement + direction
      if (indexToElementToNavigateTo >= 0 && indexToElementToNavigateTo < elements.length) {
        const navigatedToElement: HTMLAnchorElement = elements[indexToElementToNavigateTo]
        photoImg.src = navigatedToElement.href
      }
    }
  }

  function leftArrowPressed (key: string): boolean {
    return key === 'ArrowLeft'
  }

  function rightArrowPressed (key: string): boolean {
    return key === 'ArrowRight'
  }
}

export default function photo (selector: string) {
  const elements = document.querySelectorAll(selector)
  elements.forEach((elem) => {
    elem.addEventListener('click', (event: DOMEvent<HTMLElement>) => photoModal(event, selector))
  })
  addNavigation(selector)
}
